import { Injectable } from '@angular/core';

import { Injector } from '@angular/core';
import { Observable, interval, of } from 'rxjs';
import { HttpService, autoSubscribe, JsonObject, JsonProperty } from 'projects/core/src/public-api';
import { ClientNotification } from './client-nfs';
import { OrderEmail } from 'projects/desktop/src/app/modules/order/data/order-email';
import { ClientNfsResponcePage } from './client-nfs-responce-page';
import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import { Any } from 'json2typescript';



@Injectable({
    providedIn: 'root',
})
export class ClientNotificationService extends HttpService {

    constructor(
        protected injector: Injector) {
        super(injector);
    }

    getClientNf(nfsId: number): Observable<ClientNotification> {
        return this.getData(`/notification/list/for-clients/${nfsId}`, ClientNotification);
    }

    getClientNfs(start: number, limit: number): Observable<ClientNfsResponcePage> {
        return this.getData(`/notification/list/for-clients?start=${start}&limit=${limit}`, ClientNfsResponcePage);
    }

    getClientNfsEmail(clientId: number): Observable<OrderEmail> {
        return this.getData(`/notification/${clientId}/email-body`, OrderEmail);
    }

    getClientNfsForProject(projectId: number): Observable<ClientNotification[]> {
        return this.getData(`/notification/list/for-clients/for-project/${projectId}`, ClientNotification);
    }

    getConditionTypes(): Observable<ShortObject[]> {
        return this.getData(`/notification-condition/types/for-clients`, ShortObject);
    }

    sendEmail(clientId: number, emails: string, message: string): Observable<ClientNotification> {
        return this.putData(`/notification/${clientId}/send-to-client`, { emails, message }, ClientNotification)
    }

    dismissEmail(messageId: number): Observable<ClientNotification> {
        return this.putData(`/notification/${messageId}/dismiss`, {}, ClientNotification)
    }

    deleteNfs(messageId: number): Observable<any> {
        return this.deleteData(`/notification/${messageId}`, Any)
    }

    createMessage(projectId: number, condId: number): Observable<ClientNotification> {
        return this.postData(`/notification/list/for-clients/for-project/${projectId}?conditionId=${condId}`, {}, ClientNotification)
    }

}
